// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__wNL0x","title":"ClientInsurance_title__1inqn","itemText":"ClientInsurance_itemText__1Orc2"};